import React from "react";
import { Box, Typography } from "@mui/material";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import {
  designColors,
  designFontFamily,
  designWeights,
} from "services/constants/designTokens";
import { GlobalBreadcrumb } from "components/DesignSystem/sharedUiPatterns";

// The header shared by every Payroll Settings page, above the page: the
// page's breadcrumb (handed up by the page, see settingsBreadcrumb.js).
// Overview also shows "⚙ Payroll Settings" and a one-line explanation
// (showIntro); the other pages have their own title right below.
const FALLBACK_TRAIL = ["Payroll", "Payroll Settings"];

export const PayrollSettingsHeader = ({ trail, showIntro = false }) => {
  return (
    <Box
      component="header"
      sx={{ px: { xs: 1.5, md: 2 }, pt: { xs: 1.5, md: 2 }, fontFamily: designFontFamily }}
    >
      <GlobalBreadcrumb
        trail={trail && trail.length ? trail : FALLBACK_TRAIL}
        sx={showIntro ? {} : { mb: 0 }}
      />
      {showIntro && (
        <>
          <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1.25 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
              <SettingsRoundedIcon sx={{ fontSize: 24, color: designColors.slate900 }} />
              <Typography
                component="h1"
                sx={{
                  fontFamily: designFontFamily,
                  fontSize: { xs: 20, md: 24 },
                  fontWeight: designWeights.heading,
                  color: designColors.slate900,
                  lineHeight: 1.25,
                }}
              >
                Payroll Settings
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              mt: 0.5,
              fontFamily: designFontFamily,
              fontSize: 13,
              color: designColors.slate600,
            }}
          >
            Set up payroll once. Changes apply to the monthly screens.
          </Typography>
        </>
      )}
    </Box>
  );
};
